import React from 'react';

import {
  DatePickerProps,
  DateTimePickerProps,
  DatePicker as MUIDatePicker,
  DateTimePicker as MUIDateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/en-au';

import { ADAPTER_DAY_JS_LOCALE } from '../../utils/common/constants';

interface CustomDatePickerProps extends Omit<DatePickerProps<Dayjs>, 'minDate' | 'maxDate'> {
  minDate?: Dayjs | null;
  maxDate?: Dayjs | null;
}

export const DateTimePicker = ({ format = "DD MMM 'YY h:mm a", ...rest }: DateTimePickerProps<Dayjs>) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ADAPTER_DAY_JS_LOCALE}>
    <MUIDateTimePicker
      format={format}
      {...rest}
    />
  </LocalizationProvider>
);

export const DatePicker = ({ format = "DD MMM 'YY", minDate, maxDate, ...rest }: CustomDatePickerProps) => {
  // Convert null values to undefined
  const effectiveMinDate = minDate !== null ? minDate : undefined;
  const effectiveMaxDate = maxDate !== null ? maxDate : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ADAPTER_DAY_JS_LOCALE}>
      <MUIDatePicker
        format={format}
        minDate={effectiveMinDate}
        maxDate={effectiveMaxDate}
        {...rest}
      />
    </LocalizationProvider>
  );
};
